import { useEffect, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import { getSocket, joinTicketRoom, leaveTicketRoom } from "../services/socket";
import { TicketsContext } from "../context/Tickets/TicketsContextIndexedDB";

// Refcount por ticket id: cuenta cuántos componentes quieren estar
// en el room del ticket. joinTicketRoom/leaveTicketRoom solo emiten
// join/leave cuando el counter pasa de 0→1 y de 1→0 respectivamente.
const ticketRefcounts = new Map();

const acquireTicketRoom = (ticketId, companyId) => {
  const count = ticketRefcounts.get(ticketId) || 0;
  if (count === 0) {
    joinTicketRoom(ticketId, companyId);
  }
  ticketRefcounts.set(ticketId, count + 1);
};

const releaseTicketRoom = (ticketId) => {
  const count = ticketRefcounts.get(ticketId) || 0;
  if (count <= 1) {
    ticketRefcounts.delete(ticketId);
    leaveTicketRoom(ticketId);
  } else {
    ticketRefcounts.set(ticketId, count - 1);
  }
};

const resolveTicketId = (rawTicketId, ticketsList) => {
  if (rawTicketId == null) return null;

  if (typeof rawTicketId === "number") return rawTicketId;

  if (/^\d+$/.test(String(rawTicketId))) {
    return Number(rawTicketId);
  }

  const found = ticketsList?.find((t) => t.uuid === rawTicketId);
  return found?.id ?? null;
};

export const useTicketRoom = (explicitTicketId) => {
  const { ticketId: pathTicketId } = useParams();
  const { ticketsList } = useContext(TicketsContext);

  const companyIdRef = useRef(localStorage.getItem("companyId"));
  const cachedRawRef = useRef(null);
  const cachedIdRef = useRef(null);

  const rawTicketId = explicitTicketId != null ? explicitTicketId : pathTicketId;

  if (cachedRawRef.current !== rawTicketId) {
    cachedRawRef.current = rawTicketId;
    cachedIdRef.current = null;
  }

  const fromList = resolveTicketId(rawTicketId, ticketsList);
  if (fromList != null) {
    cachedIdRef.current = fromList;
  }
  const resolvedTicketId = fromList ?? cachedIdRef.current;

  useEffect(() => {
    if (resolvedTicketId == null) return undefined;

    const companyId = companyIdRef.current;
    getSocket(companyId);
    acquireTicketRoom(resolvedTicketId, companyId);

    return () => {
      releaseTicketRoom(resolvedTicketId);
    };
  }, [resolvedTicketId]);
};
